module.exports = __webpack_public_path__ + "img/successful.e7ce10ca.svg";